var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiAnalyzing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 6.75L15.1875 4.6875L17.25 3.75L15.1875 2.8125L14.25 0.75L13.3125 2.8125L11.25 3.75L13.3125 4.6875L14.25 6.75ZM8.625 7.125L6.75 3L4.875 7.125L0.75 9L4.875 10.875L6.75 15L8.625 10.875L12.75 9L8.625 7.125ZM14.25 11.25L13.3125 13.3125L11.25 14.25L13.3125 15.1875L14.25 17.25L15.1875 15.1875L17.25 14.25L15.1875 13.3125L14.25 11.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiAnalyzing);
export default __webpack_public_path__ + "static/media/ai-analyzing.e2a7f81b9e54204a5382d7b4a3cf2c77.svg";
export { ForwardRef as ReactComponent };